import { Theme } from "@emotion/react";
import styled, { Interpolation } from "@emotion/styled";
import { theme } from "styles/theme";

const AvatarContainer = styled.div<{ image?: string; size?: number; styles?: Interpolation<Theme> }>`
    width: ${(props) => props.size}px;
    height: ${(props) => props.size}px;
    background: ${(props) => (props.image ? `url(${props.image})` : theme.neutral50)} no-repeat;
    background-color: ${theme.neutral100};
    background-size: cover;
    border-radius: 100%;
    ${(props) => props.styles};
`;
export default function Avatar({ image, size = 50, styles }: { image?: string; size?: number; styles?: Interpolation<Theme> }) {
    return <AvatarContainer image={image} size={size} styles={styles} />;
}
